import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useIsAppEnabled from '../../../../../../../../LiveContext/ApplicationSyncContext/useIsAppEnabled';
import StyledBox from './styles';

export default function Legend() {
  const isAppEnabled = useIsAppEnabled();
  const { t } = useTranslation();
  if (!isAppEnabled) return null;
  return (
    <>
      <Divider />
      <StyledBox>
        <Box>
          <GraphicEqIcon />
          <Typography variant="body1">{t('detections.fromClient.title')}</Typography>
        </Box>
        <Box>
          <GraphicEqIcon />
          <Typography variant="body1">{t('detections.fromAgent.title')}</Typography>
        </Box>
      </StyledBox>
    </>
  );
}
